export const enum TabBarPosition {
    CENTER,
    LEFT,
    RIGHT,
}
